"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegenerationAbilityHandler = exports.RegenerationActorAbilityFactory = exports.RegenerationAbilityArgs = void 0;
const __1 = require("../..");
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Regeneration_1 = require("../../core/effects/core/Regeneration");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
class RegenerationAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Regeneration;
        this.__typeName = "Regeneration";
    }
}
exports.RegenerationAbilityArgs = RegenerationAbilityArgs;
let RegenerationActorAbilityFactory = class RegenerationActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Regeneration", "OneAllies", 0);
    }
};
RegenerationActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Regeneration")
], RegenerationActorAbilityFactory);
exports.RegenerationActorAbilityFactory = RegenerationActorAbilityFactory;
let RegenerationAbilityHandler = class RegenerationAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedAllyOrSelf] = ability.args.target.actorIds;
        sequence.push(new core_1.AnimateCharacterAbilityVfxStepArgs(ability.invokerId, "Regeneration", "casting"));
        container.applyBuff({
            creatorId: ability.invokerId,
            targetId: selectedAllyOrSelf,
            effect: new Regeneration_1.RegenerationEffectArgs("Regeneration", container.getPercentOfBaseHealth(selectedAllyOrSelf, 3)),
            duration: Duration_1.Duration.Turns(5),
            sequence,
            onApplied: (sequence) => {
                sequence.push(new __1.InstantVfxStepArgs(new __1.ActorVfxLocationSelector(selectedAllyOrSelf, "feet"), "BlueLightPillar"));
            }
        });
    }
};
RegenerationAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Regeneration)
], RegenerationAbilityHandler);
exports.RegenerationAbilityHandler = RegenerationAbilityHandler;
